import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=0fa0164b&scoped=true"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=0fa0164b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0164b",
  null
  
)

export default component.exports